export const notificationFilters = [
  { id: "all", label: "All" },
  { id: "unread", label: "Unread" },
  { id: "jobs", label: "Jobs" },
  { id: "invoices", label: "Invoices" },
  { id: "dealerships", label: "Dealerships" },
];

export function notificationGroup(type) {
  if (String(type).startsWith("job.")) return "jobs";
  if (String(type).startsWith("invoice.") || type === "payment.recorded") return "invoices";
  if (type === "dealership.connection") return "dealerships";
  return "other";
}

export function filterNotifications(notifications, filter = "all") {
  if (filter === "all") return notifications;
  if (filter === "unread") return notifications.filter((notification) => notification.status === "unread");
  return notifications.filter((notification) => notificationGroup(notification.type) === filter);
}

export function notificationMetrics(notifications, now = new Date()) {
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  return {
    unread: notifications.filter((notification) => notification.status === "unread").length,
    high: notifications.filter((notification) => notification.status === "unread" && notification.priority === "high").length,
    today: notifications.filter((notification) => Date.parse(notification.createdAt ?? "") >= start.getTime()).length,
  };
}

export function validateNotificationPreferences(preferences) {
  if (preferences?.channels?.sms && !preferences?.smsConsent) return "Confirm SMS consent before enabling text notifications.";
  if (!Object.values(preferences?.events ?? {}).some(Boolean)) return "Keep at least one notification event enabled.";
  return null;
}

export function relativeNotificationTime(value, now = Date.now()) {
  const then = Date.parse(value ?? "");
  if (!Number.isFinite(then)) return "Unknown time";
  const minutes = Math.max(0, Math.round((now - then) / 60_000));
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}
